export default "__VITE_ASSET__By9QgAWp__"